// Globals
import { ReactNode } from 'react';

// Modules
import { ImageCard } from '@/modules/SharedPictures';

// Components
import { FileUpload } from '@/components';
import { UploadIcon } from '@/icons';
import { ImageGroup } from '@/ui';
import { StyledIcon, StyledWrapper } from '../../components';
import { StyledHeader, StyledList, StyledTitle } from './ImagesUploaderContainerStyles';

// Models
import { IFile } from '@/models/file.model';

type TImagesUploaderContainerProps = {
  disabled?: boolean;
  description?: ReactNode;
  children?: ReactNode;
  title?: ReactNode;
  acceptance?: string;
  maxImageSize?: number;
  imagesList?: IFile[];
  multiple?: boolean;
  onChange?: (file: File, fileList: File[]) => void;
  onDelete?: (file: IFile) => void;
  type?: 'select' | 'drag';
};

const ImagesUploaderContainer = ({
  imagesList,
  acceptance,
  children,
  onChange,
  onDelete,
  disabled,
  maxImageSize,
  multiple,
  title,
  type = 'select',
  description,
}: TImagesUploaderContainerProps) => {
  const canUpload = !imagesList?.length && !disabled;

  if (canUpload) {
    return (
      <>
        <StyledTitle>{title}</StyledTitle>
        <FileUpload
          onChange={onChange}
          maxFileSize={maxImageSize}
          disabled={disabled}
          acceptance={acceptance}
          showList={false}
          multiple={multiple}
        >
          <StyledWrapper>
            <StyledIcon>
              <UploadIcon />
            </StyledIcon>
            {description}
          </StyledWrapper>
          {children}
        </FileUpload>
      </>
    );
  }

  return (
    <div>
      <StyledHeader $type={type}>
        <StyledTitle>{title}</StyledTitle>
        {!disabled && (
          <FileUpload
            onChange={onChange}
            maxFileSize={maxImageSize}
            disabled={disabled}
            acceptance={acceptance}
            showList={false}
            type={type}
            multiple={multiple}
          >
            {type === 'drag' && (
              <StyledWrapper>
                <StyledIcon>
                  <UploadIcon />
                </StyledIcon>
                {description}
              </StyledWrapper>
            )}
            {children}
          </FileUpload>
        )}
      </StyledHeader>
      <StyledList>
        <ImageGroup>
          {imagesList?.map((file) => (
            <ImageCard key={file.id} image={file} onDelete={disabled ? undefined : onDelete} />
          ))}
        </ImageGroup>
      </StyledList>
    </div>
  );
};

export default ImagesUploaderContainer;
